export default __webpack_public_path__ + "static/media/marauders-map-v3-02-02.63c75663.jpg";